import { mainColor, UNIT } from '../../constants';

export const styles = () => ({
  errorText: {
    color: mainColor.colorRed,
    fontSize: UNIT * 0.625,
    marginTop: UNIT * 0.625
  },
  icon: {
    fontSize: UNIT * 1.5,
    color: mainColor.colorBlack
  },
  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor
  },
  produits: {
    fontSize: UNIT * 0.9375,
    minWidth: UNIT * 10.625
  },
  heading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder'
  },
  typo: {
    fontSize: UNIT * 0.875
  },

  textStyle: {
    fontWeight: 'normal',
    whiteSpace: 'nowrap',
    minHeight: '1.2em',
    padding: '0px 2px 0px',
    color: 'black'
  },
  checkboxStyle: {
    display: 'flex'
  },
  labelStyle: {
    lineHeight: 1,
    letterSpacing: '0.00938em',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  arrowIcon: { alignSelf: 'center', marginLeft: '4px !important' },
  buttonStyle: {
    padding: `${UNIT * 0.4375}px ${UNIT *0.875}px!important`
  }
});
